import { useVideoConsultationGlobalState } from '../shared/useVideoConsultationGlobalState';
import { translationKeys } from '../translations';

import { StyledVideoConsultationWindowShowButton } from './VideoConsultationWindowShowButton.styled';

export const VideoConsultationWindowShowButton = (): JSX.Element => {
   const { showWindow } = useVideoConsultationGlobalState();

   return (
      <StyledVideoConsultationWindowShowButton
         testId={'openVideoConsultation'}
         type={'button'}
         onClick={showWindow}
         label={translationKeys.restoreWindow}
      />
   );
};
